import store from '../store'
const ERROR_KEY = 'error'

const storeError = message => store.set(ERROR_KEY, message)
const loadError = () => store.get(ERROR_KEY)

export { storeError, loadError, ERROR_KEY }
